import { makeAutoObservable, runInAction } from "mobx";

export default class clusteringStore {
  data = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.data = [];
    runInAction(() => {
      this.data = data;
    });
  };

  
}
